import React, { ComponentProps } from 'react';

import SeeMore from './SeeMore';

type ActivityTextProps = ComponentProps<typeof SeeMore>;

const collapsedStyle = {
  '-webkit-line-clamp': '3',
};

/**
 * ActivityText component. Describes an expandable text component.
 */
const ActivityText = React.forwardRef<HTMLDivElement, ActivityTextProps>(
  ({ text, children, ...props }, ref) => {
    return (
      <SeeMore
        ref={ref}
        text={text}
        collapsedStyle={collapsedStyle}
        {...props}
      />
    );
  }
);

ActivityText.displayName = 'ActivityText';

ActivityText.propTypes = {
  ...SeeMore.propTypes,
};

export default ActivityText;
